import { useNavigate } from 'react-router-dom'

import SignUpScreen from '@/components/screens/SignUpScreen'

const SignUp = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center p-4">
      <SignUpScreen
        onBack={() => navigate('/')}
        onSignUpSuccess={(email) => {
          localStorage.setItem('email', email)
          navigate('/Complete24')
        }}
        onSignIn={() => navigate('/')}
      />
    </div>
  )
}

export { SignUp }
